import { PersonInfo, Pronoun, ROLE } from '../../consts';
import image from './sloan-sparger.jpg';

export const SloanSparger: PersonInfo = {
  firstName: 'Sloan',
  lastName: 'Sparger',
  image,
  pronoun: Pronoun.HE,
  role: ROLE.SOFTWARE_ENGINEER,
};
